import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { reportUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import globalStore from '@/stores/index';
import { getPageConfig } from '@/pages/agency/utils/util';
import dialog from '@/utils/dialog';
import { OverlayTrigger, PopOver, Button } from '@tencent/spaui';
import { FLAGS } from '@/constants/Constants';

const NAV_LIST_MAX_ROWS = 5;

const NavTitle = (props = {}) => {
  const { title, childRef } = props;

  return (
    <h3 className="nav-sub-title" ref={childRef}>
      <a>{title}</a>
    </h3>
  );
};

// 给子菜单添加 popover 提示内容
const PopoverInfo = ({ name, popoverInfo, url }) => {
  const key = `${FLAGS.GUIDE_TIP_STORAGE.SUB_MENU_KEY}_${url}`;
  const [show, setShow] = useState(popoverInfo && !localStorage.getItem(key));

  if (show) {
    return (
      <PopOver className="dark" placement='right'>
        <h4 className="spaui-popover-title">{`新功能"${name}"`}</h4>
        <div className="spaui-popover-body">{popoverInfo}</div>

        <div className="spaui-popover-footer">
          <span onClick={(e) => {
            localStorage.setItem(key, 1);
            setShow(false);
          }}>我知道了</span>
        </div>
      </PopOver>
    );
  }
  return null;
};

const NavList = (props = {}) => {
  const { data = [], onLinkMouseEnter, onLinkMouseLeave } = props;
  const len = data.length;
  const history = globalStore.history || {};
  // 列数
  const columns = Math.ceil(len / NAV_LIST_MAX_ROWS);
  const list = [];

  const onClickUrl = (item) => {
    const { useNavOpenReport = false, navOpenReportParams = {}, tree } = item;
    if (useNavOpenReport) {
      const [page1, page2] = tree;
      const params = {
        page1,
        page2,
        behavior: '打开页面',
        ...navOpenReportParams,
      };
      reportUserBehaviorCgi({ data: params });
    }
  };

  const onClickJump = (url) => {
    const haveJumpPermissions = !getPageConfig(url).pagePurview.notYetOpen?.(globalStore.account);

    if (haveJumpPermissions) {
      history.push(url);
    } else {
      dialog.alert('您好，此版块详情内容尚未开放，申请流程待进一步通知或咨询对应渠道经理');
    }
  };

  for (let i = 0; i < columns; i += 1) {
    list.push(<div className="nav-sub-list">
        <ul>
          {data.slice(i * NAV_LIST_MAX_ROWS, (i + 1) * NAV_LIST_MAX_ROWS).map((item, index) => {
            const { name, url, target, desc, list, isNew = false, popoverInfo } = item;
            return (
              <li
                key={index}
                className={classNames({
                  'has-nav-links': list,
                })}
              >
                {target === '_blank' ? (
                  <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    data-desc={desc}
                    onMouseEnter={onLinkMouseEnter}
                    onMouseLeave={onLinkMouseLeave}
                    className={list ? 'nav-links-name' : null}
                    onClick={() => onClickUrl(item)}
                    data-report-global={`nav.${item.key || url}`}
                  >
                    {name}
                  </a>
                ) : (
                  <a
                    href='javascript: void(0)'
                    rel="noreferrer"
                    data-desc={desc}
                    onMouseEnter={onLinkMouseEnter}
                    onMouseLeave={onLinkMouseLeave}
                    className={list ? 'nav-links-name' : null}
                    onClick={() => {
                      onClickJump(url);
                      onClickUrl(item);
                    }}
                    data-report-global={`nav.${item.key || url}`}
                  >
                    {name}
                  </a>
                  // <NavLink
                  //   to={url}
                  //   target={target}
                  //   data-desc={desc}
                  //   onMouseEnter={onLinkMouseEnter}
                  //   onMouseLeave={onLinkMouseLeave}
                  //   className={list ? 'nav-links-name' : null}
                  //   data-report-global={`nav.${item.key || url}`}
                  // >
                  //   {name}
                  // </NavLink>
                )}
                {isNew ? (
                  <span className="new-icon">
                    <PopoverInfo name={name} url={url} popoverInfo={popoverInfo} />
                  </span>
                ) : null}
                {list ? (
                  <span className="nav-links">
                    {list.map((it, j) => (
                      <NavLink to={it.url} target={it.target} key={j}>
                        {it.name}
                      </NavLink>
                    ))}
                  </span>
                ) : null}
              </li>
            );
          })}
        </ul>
      </div>);
  }

  return (
    <div className="nav-sub-list-group">
      {list}
    </div>
  );
};

const NavSub = (props = {}) => {
  const { data = [], desc: defaultDesc = '', addon } = props;
  const [desc, setDesc] = useState(defaultDesc);

  return (
    <div className="nav-sub">
      <div className="nav-sub-inner">
        <div className="nav-sub-grid">
          {data.map((item, index) => {
            const { title, list, additional } = item;

            const Tag = additional ? 'div' : React.Fragment;
            const TagProps = additional
              ? {
                className: 'nav-sub-list-group',
              }
              : null;

            if (!list.length) return null;

            return (
              <div className={classNames('nav-sub-group', { 'has-addition': additional })} key={index}>
                <NavTitle title={title} />
                <Tag {...TagProps}>
                  <NavList
                    data={list}
                    onLinkMouseEnter={(e) => setDesc(e.target.dataset.desc)}
                    onLinkMouseLeave={() => setDesc(defaultDesc)}
                  />
                  {
                    additional ? (
                      <NavList
                        data={additional[0].list}
                        onLinkMouseEnter={(e) => setDesc(e.target.dataset.desc)}
                        onLinkMouseLeave={() => setDesc(defaultDesc)}
                      />
                    ) : null
                  }
                </Tag>
              </div>
            );
          })}
        </div>
        {addon}
        <div className="nav-sub-foot">
          <p className="nav-sub-tips">
            {desc}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NavSub;
